document.addEventListener("alpine:init", () => {
  Alpine.store("cart", {
    open: false,
    loading: false,
    error: null,
    count: 0,
    total_price: 0,

    money(cents) {
      const c = Shopify?.currency?.active || "USD";
      return new Intl.NumberFormat(undefined, {
        style: "currency",
        currency: c,
      }).format((cents || 0) / 100);
    },

    get cartTotal() {
      return this.total_price;
    },

    quantityFor({ line }) {
      const el = document.querySelector(
        `[data-line="${line}"] input[type="number"]`
      );
      return el ? +el.value : 0;
    },

    async fetchCart() {
      try {
        const r = await fetch("/cart.js");
        const cart = await r.json();
        this.count = cart.item_count;
        this.total_price = cart.total_price;

        const badge = document.querySelector("[data-cart-count]");
        if (badge) badge.textContent = this.count;
      } catch {
        this.error = "Failed to load cart.";
      }
    },

    _drawerSectionId() {
      return (
        document.getElementById("CartDrawer")?.dataset.sectionId ||
        "cart-drawer"
      );
    },

    async refreshSections({ refreshHeader = true } = {}) {
      this.loading = true;
      const drawerId = this._drawerSectionId();
      const targets = refreshHeader ? `${drawerId},header` : drawerId;
      const res = await fetch(`/?sections=${targets}`);
      const html = await res.json();

      // Reemplazar inner del drawer
      const wrap = document.createElement("div");
      wrap.innerHTML = html[drawerId] || "";
      const freshInner = wrap.querySelector("#CartDrawerInner");
      if (freshInner) {
        const current = document.getElementById("CartDrawerInner");
        current?.replaceWith(freshInner);

        // Re-initialize Swiper after AJAX update
        function initSwiperRecommendation() {
          var selector = ".swiper-recommendation";
          if (window.Swiper && document.querySelector(selector)) {
            new Swiper(selector, {
              slidesPerView: 3,
              spaceBetween: 7,
              rewind: true,
              navigation: {
                nextEl: ".recommendations .slider-next",
                prevEl: ".recommendations .slider-prev",
              },
            });
          }
        }
        initSwiperRecommendation();
      }
      await this.fetchCart();
      this.loading = false;
    },

    async add({ id, quantity = 1, properties = {} }) {
      this.loading = true;
      try {
        const r = await fetch("/cart/add.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ items: [{ id, quantity, properties }] }),
        });
        if (!r.ok) throw await r.json();
        await this.refreshSections();
        this.openDrawer();
      } catch (e) {
        this.error = e?.description || "We were unable to add the product.";
      } finally {
        this.loading = false;
      }
    },

    async change({ line, qty }) {
      this.loading = true;
      try {
        const r = await fetch("/cart/change.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ line, quantity: qty }),
        });
        if (!r.ok) throw await r.json();
        await this.refreshSections();
      } catch {
        this.error = "No se pudo actualizar la cantidad.";
      } finally {
        this.loading = false;
      }
    },

    async remove({ line }) {
      return this.change({ line, qty: 0 });
    },

    openDrawer() {
      this.open = true;

      this.refreshSections();
    },
    closeDrawer() {
      this.open = false;
    },
  });

  Alpine.data("cartDrawer", () => ({
    get open() {
      return Alpine.store("cart").open;
    },
    set open(v) {
      Alpine.store("cart").open = v;
    },
    get cartTotal() {
      return Alpine.store("cart").cartTotal;
    },
    money: (cents) => Alpine.store("cart").money(cents),

    init() {
      Alpine.store("cart").fetchCart();
      // cerrar con ESC
      this.$watch("open", (o) => {
        if (o) document.addEventListener("keydown", this._esc);
        else document.removeEventListener("keydown", this._esc);
      });

      // Initialize Swiper on first load
      function initSwiperRecommendation() {
        var selector = ".swiper-recommendation";
        if (window.Swiper && document.querySelector(selector)) {
          new Swiper(selector, {
            slidesPerView: 3,
            spaceBetween: 7,
            rewind: true,
          });
        }
      }
      initSwiperRecommendation();
    },
    _esc(e) {
      if (e.key === "Escape") Alpine.store("cart").closeDrawer();
    },
    close() {
      Alpine.store("cart").closeDrawer();
    },
  }));
});
